import React from 'react';
import _ from 'lodash';

import {
  useOrderChatMessagesWidgetQuery,
  usePartner_ReturnAuthorizationChatMessagesWidgetQuery
} from 'generated/graphql';

import { DateTime } from 'luxon';
import { ChatMessageList } from 'modules/layer01';



export interface IData {
  chatMessages: ChatMessageList.IMessage[];
}

export function useQuery(orderId: string) {
  const tuple = useOrderChatMessagesWidgetQuery({
    variables: {
      orderId
    }
  });



  return React.useMemo(() => {
    const data: IData = {
      chatMessages: _.map(tuple.data?.order?.messages.nodes ?? [], (msg): ChatMessageList.IMessage => ({
        id: msg.id,
        metaCreated: DateTime.fromISO(msg.metaCreated),
        content: msg.content,
        senderUserName: msg.senderName || 'N/A'
      }))
    };

    return {
      ...tuple,
      data
    };
  }, [tuple]);
}



export function useReturnAuthorizationQuery(returnAuthorizationId: string) {
  const tuple = usePartner_ReturnAuthorizationChatMessagesWidgetQuery({
    variables: {
      returnAuthorizationId
    }
  });



  return React.useMemo(() => {
    const data: IData = {
      chatMessages: _.map(tuple.data?.returnAuthorization?.messages.nodes ?? [], (msg): ChatMessageList.IMessage => ({
        id: msg.id,
        metaCreated: DateTime.fromISO(msg.metaCreated),
        content: msg.content,
        senderUserName: msg.senderName || 'N/A'
      }))
    };

    return {
      ...tuple,
      data
    };
  }, [tuple]);
}
